export default __webpack_public_path__ + "static/media/HistoryBgImg.12f6dbdb.jpg";